var exports = {
  "IL": "ConfirmModal.module__messagePreview___SXFmWW",
  "sA": "ConfirmModal.module__messagePreviewOverflowing___SXFmWW",
  "ey": "ConfirmModal.module__shiftBypassTip___SXFmWW",
  "iH": "ConfirmModal.module__shiftBypassTipLabel___SXFmWW",
};

module.exports = exports;
